var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 9c-.552 0-1-.449-1-1 0-.551.448-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zm0-3.333C6.713 5.667 5.666 6.713 5.666 8c0 1.287 1.047 2.333 2.334 2.333 1.286 0 2.333-1.046 2.333-2.333 0-1.287-1.047-2.333-2.333-2.333zm.146 5.665c-2.87.066-4.743-2.389-5.364-3.335.684-1.07 2.406-3.26 5.072-3.329 2.859-.072 4.742 2.39 5.363 3.335-.683 1.07-2.406 3.26-5.07 3.329zm6.432-3.664c-.425-.74-2.774-4.457-6.758-4.332-3.686.093-5.83 3.34-6.398 4.332-.118.206-.118.458 0 .664.419.731 2.686 4.334 6.594 4.334.055 0 .11 0 .164-.002 3.685-.094 5.829-3.34 6.398-4.332.117-.206.117-.458 0-.664z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/active.ccc00b09.svg";
export { ForwardRef as ReactComponent };